import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = { class: "subject-tabs-panel" }
const _hoisted_3 = { class: "code-buttons-panel" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Revoke ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Start new assessment ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_InfoIcon = _resolveComponent("InfoIcon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_CancelIcon = _resolveComponent("CancelIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event)),
        onTabClick: _ctx.changeTab
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              label: link.label,
              name: link.url,
              key: link.url
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _createVNode("div", _hoisted_3, [
        (_ctx.assessment)
          ? (_openBlock(), _createBlock("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.subjectCodeStatus) + " ", 1),
              (_ctx.subjectCodeStatus === _ctx.CodeStatus.Generated)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    class: "item",
                    effect: "light",
                    content: _ctx.assessment.invitation_code_value,
                    placement: "right",
                    disabled: !_ctx.forbidForRole(_ctx.UserRole.Analyst)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InfoIcon)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.forbidForRole(_ctx.UserRole.Analyst))
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              (
              _ctx.subjectCodeStatus === _ctx.CodeStatus.Generated ||
                _ctx.subjectCodeStatus === _ctx.CodeStatus.Entered
            )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "edit-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.revoke()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CancelIcon),
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "edit-button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startNewAssessment()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PlayCircleIcon),
                      _hoisted_6
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.subject)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          subject: _ctx.subject
        }, null, 8, ["subject"]))
      : _createCommentVNode("", true)
  ]))
}